export const durations = {
  '75': 'tw-duration-75',
  '100': 'tw-duration-100',
  '150': 'tw-duration-150',
  '200': 'tw-duration-200',
  '300': 'tw-duration-300',
  '500': 'tw-duration-500',
  '700': 'tw-duration-700',
  '1000': 'tw-duration-1000',
} as const;

export const propsDefaults = {
  duration: '500' as keyof typeof durations,
};
